import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {CaseRequestType, SaveCaseRequestType} from "../models/case-request-type";

@Injectable({
  providedIn: 'root'
})
export class CaseRequestTypeService {

  constructor(private httpClient: HttpClient) {}

  getCaseRequestTypes(includeInactive = false): Observable<CaseRequestType[]> {
    return this.httpClient.get<CaseRequestType[]>(
      `${environment.apiUrl}/api/case-request-types`,
      {params: {includeInactive}}
    );
  }

  createCaseRequestType(requestType: SaveCaseRequestType): Observable<{value: string}> {
    return this.httpClient.post<{value: string}>(`${environment.apiUrl}/api/case-request-types`, requestType);
  }

  updateCaseRequestType(requestType: SaveCaseRequestType): Observable<void> {
    return this.httpClient.put<void>(`${environment.apiUrl}/api/case-request-types/${requestType.id}`, requestType);
  }
}
